/**
 * Auth constants — timing values imported from constant.js.
 *
 * For a 1 hour JWT (every API request needs a valid Bearer token):
 *   ACCESS_TOKEN_REFRESH_THRESHOLD_MS = 5 min → refresh at ~55 min if user is active
 *   IDLE_WARNING_MS                   = 58 min → popup after inactivity
 *   IDLE_DIALOG_AUTO_LOGOUT_SECONDS   = 60s    → Stay refreshes; no action logs out
 *   IDLE_FORCE_LOGOUT_MS              = 59 min → 58 min + 60s (slightly before JWT ends)
 *
 * Do not set ACCESS_TOKEN_REFRESH_THRESHOLD_MS >= JWT TTL — isNearExpiry() would
 * always be true and every request would hit /auth/refresh.
 *
 * Prod values commented below; swap import when deploying.
 */

import {
  ACCESS_TOKEN_REFRESH_THRESHOLD_MS,
  ACTIVITY_DEBOUNCE_MS,
  IDLE_DIALOG_AUTO_LOGOUT_SECONDS,
  IDLE_FORCE_LOGOUT_MS,
  IDLE_WARNING_MS,
} from "components/ui/utils/constant";

// --- Previous prod (commented) ---
// export const ACCESS_TOKEN_REFRESH_THRESHOLD_MS = 5 * 60 * 1000; // 5 minutes
// export const ACTIVITY_DEBOUNCE_MS = 5000; // 5 seconds
// export const IDLE_FORCE_LOGOUT_MS = 59 * 60 * 1000; // 59 minutes
// export const IDLE_DIALOG_AUTO_LOGOUT_SECONDS = 60; // 1 minute
// export const IDLE_WARNING_MS = 58 * 60 * 1000; // 58 minutes

export {
  ACCESS_TOKEN_REFRESH_THRESHOLD_MS,
  ACTIVITY_DEBOUNCE_MS,
  IDLE_DIALOG_AUTO_LOGOUT_SECONDS,
  IDLE_FORCE_LOGOUT_MS,
  IDLE_WARNING_MS,
};

export const PENDING_2FA_STATUSES = [
  "otp_required",
  "verify_authenticator",
  "setup_authenticator",
];

export const SESSION_TYPE = {
  PORTAL: "portal",
  ADMIN: "admin",
};

export const IDLE_DIALOG_TITLE = "Session expired";
export const IDLE_DIALOG_MESSAGE =
  "You've been inactive for a while. Do you want to stay signed in?";
